import React from 'react';

interface HeaderProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onClearSearch: () => void;
}

const Header: React.FC<HeaderProps> = ({ 
  searchQuery, 
  onSearchChange, 
  onClearSearch 
}) => {
  return (
    <div className="px-8 py-6 text-white flex-shrink-0" style={{ background: `linear-gradient(135deg, #778788 0%, #1f2d33 100%)` }}>
      <div className="flex items-center justify-between">
        {/* Logo and title section */}
        <div className="flex items-center">
          <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mr-4 backdrop-blur-sm">
            <img src="/logo.png" alt="HEBI Logo" className="w-8 h-8" />
          </div>
          <div>
            <h1 className="text-3xl font-bold">HEBI Files</h1>
          </div>
        </div>
        
        {/* Search section */}
        <div className="flex items-center space-x-3">
          {/* Search input with clear button */}
          <div className="relative">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Search this directory"
              autoFocus={!!searchQuery}
              className="pl-4 pr-12 py-3 text-sm bg-white/20 border border-white/30 rounded-lg text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-transparent transition-all duration-200"
              style={{ width: '320px', height: '44px' }}
            />
            {/* Clear search button - only shown when there's a search query */}
            {searchQuery && (
              <button
                onClick={onClearSearch}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 text-white hover:text-white/90 transition-colors p-1"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ strokeWidth: 2, filter: 'none' }}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
